import SchemaForm from 'components/forms/SchemaForm'
import dotProp from "dot-prop";
import React from 'react'
import { connect } from 'react-redux'
import { Message } from "semantic-ui-react";
import { fetchEntities } from "../../actions/entities";
import templateSchema from "../../forms/templateSchema";

class TemplateForm extends React.Component {

  render () {
    return (
      <React.Fragment>
        {this.props.readonly ? <Message>{I18n.t('api.forms.not_in_scope')}</Message> : null}
          <SchemaForm entityName='template' {...this.props}/>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let readonly = dotProp.get(state, `entities.template.byId.${ownProps.entityId}.readOnly`)

  return {
    uiSchema: templateSchema(state, ownProps),
    readonly: readonly
  }
}

TemplateForm.defaultProps = {
  submitButton: true
}

export default connect(mapStateToProps)(TemplateForm);

